import {
  ICIMB_CHECKER_ROLE,
  ICIMB_LEADER_ROLE,
  ICIMB_MAKER_ROLE,
  ICIMB_MEMBER_ROLE,
  USER_AVAILABILITY,
  USER_ROLE,
  USER_STATUS,
} from '../data/user.data';

export type UserRole = typeof USER_ROLE[number]['value'];
export type UserMemberRole = typeof ICIMB_MEMBER_ROLE[number]['value'];
export type UserLeaderRole = typeof ICIMB_LEADER_ROLE[number];
export type UserMakerRole = typeof ICIMB_MAKER_ROLE[number];
export type UserCheckerRole = typeof ICIMB_CHECKER_ROLE[number];
export type UserStatusType = typeof USER_STATUS[number]['value'];
export type UserAvailabilityType = typeof USER_AVAILABILITY[number]['value'];
